var React = require('react');

function SVGIcon (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fill":"currentColor","d":"M12.8555 20C17.2737 20 20.8555 16.4183 20.8555 12C20.8555 7.58172 17.2737 4 12.8555 4C8.43719 4 4.85547 7.58172 4.85547 12C4.85547 16.4183 8.43719 20 12.8555 20ZM12.8555 21C17.826 21 21.8555 16.9706 21.8555 12C21.8555 7.02944 17.826 3 12.8555 3C7.88491 3 3.85547 7.02944 3.85547 12C3.85547 16.9706 7.88491 21 12.8555 21Z","key":0}),React.createElement("rect",{"fill":"currentColor","x":"8.85547","y":"9","width":"8","height":"2","key":1}),React.createElement("rect",{"fill":"currentColor","x":"8.85547","y":"13","width":"8","height":"2","key":2})]);
}

SVGIcon.defaultProps = {"viewBox":"0 0 25 24"};

module.exports = SVGIcon;

SVGIcon.default = SVGIcon;
